import React from "react"
import classnames from "classnames"
import Button from "./button"
import * as styles from "./quote.module.css"
import { getLinkDataFromCta } from "@utils/routing"
import RichText from "@components/rich-text"

const CTA = ({ cta }) => {
  if (!cta) return <></>;

  const { text: linkText, url, mode } = getLinkDataFromCta(cta);
  const minWidth = cta?.minWidth ? { minWidth: cta.minWidth, justifyContent: 'center' } : {};

  return (
    <>
      {mode === 'internal' && <div className="pt-4 mx-auto text-center"><Button internalLink={url} style={minWidth}>{linkText}</Button></div>}
      {mode === 'external' && <div className="pt-4 mx-auto text-center"><Button externalLink={url} style={minWidth}>{linkText}</Button></div>}
    </>
  )
}

const Quote = ({ id, subtitle, text, quoteText, credit, cta, secondaryCta, includeQuotationMarks }) => {

  return (
    <blockquote id={id ? id : 'noid'} className={classnames('w-full', 'm-0', 'text-center')}>
      {subtitle && <h4 className="mb-2.5 md:mb-5 subquote antialiased not-italic tracking-widest uppercase text-dark-gray font-bold">
        {subtitle}
      </h4>}
      <div className="max-w-4xl mx-auto text-2xl font-bold text-center text-gray-900 sm:text-4xl text-soft-black">
        <RichText removeOtherClasses={true} text={text || quoteText} paragraphClassName={classnames({ [styles.text]: includeQuotationMarks })} />
      </div>
      {credit && (
        <footer className="">
          <cite className="text-sm antialiased not-italic leading-5 tracking-widest uppercase text-darker-gray font-bold">
            - {credit}
          </cite>
        </footer>
      )}
      <CTA cta={cta} />
      <CTA cta={secondaryCta} />
    </blockquote>
  )
}

export default Quote
